export default __webpack_public_path__ + "66b347495dc1995b5ce81c5979f18579.png";